import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import { authUser } from "./fake-db";
import {
  ListItemIcon,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import AccountModal from "../../../Common/SwitchAccountsModal";
import SwitchUsersModal from "app/Common/SwitchUsersModal";
import UserTimezoneModal from "app/Common/UserTimezoneModal";
import { dispatch } from "app/store/store";
import {
  showHideSwitchAccountModal,
  showHideSwitchUserModal,
  showHideUserTimezoneModal,
  // GetAllGlobalAccountsListThunk,
  // GetAllGlobalCompaniesListThunk,
  // GetAllGlobalPublishersListThunk,
  // GetAllGlobalAdvertisersListThunk,
  // GetAllGlobalContentTypesListThunk,
  // GetAllGlobalUsersListThunk,
} from "app/store/slice/common-slice";
import { setAuthToken } from "@jumbo/services/auth/jwtAuth";
import { logOut } from "app/store/slice/login-slice";
import { useSelector } from "react-redux";
import { getAssetPath } from "app/utils/appHelpers";
import { ASSET_AVATARS } from "app/utils/constants/paths";
// import { GetAllCompainesListThunk } from "app/store/slice/company-slice";
// import { GetAllPublishersListThunk } from "app/store/slice/publisher-slice";
import ScheduleIcon from '@mui/icons-material/Schedule';
const AuthUserDropdown = () => {
  const navigate = useNavigate();
  const { theme } = useJumboTheme();
  //const { setAuthToken } = useJumboAuth();

  const [openSwitchAccModal, setOpenSwitchAccModal] = useState(false);
  const { authUserData } = useSelector((state) => state.CommonReducer);

  const onLogout = () => {
    setAuthToken(null);
    dispatch(logOut());
  };

  return (
    <ThemeProvider theme={theme}>
      <JumboDdPopover
        triggerButton={
          <Avatar
            src={getAssetPath(`${ASSET_AVATARS}/avatar3.png`, `60x60`)}
            sizes={"small"}
            sx={{ boxShadow: 25, cursor: "pointer" }}
          />
        }
      >
        <Div
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: (theme) => theme.spacing(2.5),
            minWidth: "240px"
          }}
        >
          <Avatar
            src={getAssetPath(`${ASSET_AVATARS}/avatar3.png`, `60x60`)}
            alt={authUserData.name}
            sx={{ width: 60, height: 60, mb: 2 }}
          />
          <Typography variant={"h5"}>{authUserData.name}</Typography>
          <Typography variant={"body1"} color="text.secondary">
            {authUserData.email}
          </Typography>
        </Div>
        <Divider />
        <nav>
          <List disablePadding sx={{ pb: 1 }}>
            {/* <ListItemButton>
                    <ListItemIcon sx={{minWidth: 36}}>
                        <PersonOutlineIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Profile" sx={{my: 0}}/>
                </ListItemButton>
                <ListItemButton>
                    <ListItemIcon sx={{minWidth: 36}}>
                        <EditOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Edit Profile" sx={{my: 0}}/>
            </ListItemButton> */}
            {/* <ListItemButton
              onClick={() => dispatch(showHideSwitchAccountModal(true))}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <RepeatOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Switch Account" sx={{ my: 0 }} />
            </ListItemButton> */}

            <ListItemButton
              onClick={() => dispatch(showHideSwitchUserModal(true))}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <RepeatOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Switch User" sx={{ my: 0 }} />
            </ListItemButton>
            {/* <ListItemButton
              onClick={() => dispatch(showHideUserTimezoneModal(true))}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText primary="Change Timezone" sx={{ my: 0 }} />
            </ListItemButton> */}

            <ListItemButton onClick={onLogout}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" sx={{ my: 0 }} />
            </ListItemButton>
          </List>
        </nav>
      </JumboDdPopover>
      <AccountModal isOpen={openSwitchAccModal} />
      <SwitchUsersModal />
      <UserTimezoneModal />
    </ThemeProvider>
  );
};

export default AuthUserDropdown;
